import React, { useState } from 'react';
import './ShippingOptions.css';

const PARTNERS = [
    'Gary the Snail Logistics',
    'Carrier Pigeon Express',
    'The Neighborhood Raccoon Brigade',
    'Migrating Goose Cargo',
    'Golden Retriever Courier',
    'Trebuchet Air Freight',
    'Message in a Bottle Marine',
    'Tumbleweed Transit',
    'Quantum Superposition Post',
    'Boomerang Ground Shipping',
    'Steve on a Unicycle',
    'Toddler Courier Services',
    'The Passive-Aggressive Paperboy',
    'Unsupervised Roomba Fleet',
];

function ShippingOptions({ theme, onBackClick, onConfirm }) {
    const [selected, setSelected] = useState(PARTNERS[0]);

    const PARTNER_META = {
        'Gary the Snail Logistics': { emoji: '🐌', desc: 'Guaranteed delivery within 3–5 business years. Slow, but reliable... eventually.' },
        'Carrier Pigeon Express': { emoji: '🕊️', desc: 'Packages may arrive with slight beak marks. Excellent for small envelopes.' },
        'The Neighborhood Raccoon Brigade': { emoji: '🦝', desc: "They only deliver at 3:00 AM and may rummage through your trash en route." },
        'Migrating Goose Cargo': { emoji: '🪿', desc: 'Service suspended seasonally; migratory patterns dictate delivery windows.' },
        'Golden Retriever Courier': { emoji: '🦮', desc: "Picked up enthusiastically; may get distracted by a tennis ball en route." },
        'Trebuchet Air Freight': { emoji: '🪃', desc: 'We launch packages from afar. Roof strikes are not our responsibility.' },
        'Message in a Bottle Marine': { emoji: '🏝️', desc: 'Ideal for coastal customers; delivery depends on favorable currents.' },
        'Tumbleweed Transit': { emoji: '🌵', desc: 'Completely reliant on wind speed and direction. Good luck.' },
        'Quantum Superposition Post': { emoji: '🌀', desc: 'Your package is both here and not until you look at the porch.' },
        'Boomerang Ground Shipping': { emoji: '🪃', desc: 'Packages tend to return to sender moments before arrival.' },
        'Steve on a Unicycle': { emoji: '🤹', desc: "Steve is trying his best; payload size limited to a toaster." },
        'Toddler Courier Services': { emoji: '🧸', desc: 'Arrives sticky and decorated in crayon; may be delivered nearby.' },
        'The Passive-Aggressive Paperboy': { emoji: '🗞️', desc: 'Likely to aim for your front window. Consider a safer address.' },
        'Unsupervised Roomba Fleet': { emoji: '🤖', desc: 'They will slowly bump their way toward your address via the interstate.' },
    };

    const handleConfirm = () => {
        onConfirm(selected);
    };

    return (
        <div className={`app ${theme}`}>
            <main>
                <section className="shipping-header-section">
                    <div className="shipping-header">
                        <div>
                            <h1>Choose Your Delivery Partner</h1>
                            <p className="shipping-subtitle">Pick one of our delightfully unreliable carriers</p>
                        </div>
                        <button className="back-btn" onClick={onBackClick}>
                            Back to Checkout
                        </button>
                    </div>
                </section>

                <section className="shipping-content">
                    <div className="shipping-card">
                        <p className="parody-note">This is a parody website — items are not actually shipped.</p>


                        <div className="partner-summary">
                            <div className="summary-emoji">{PARTNER_META[selected].emoji}</div>
                            <div className="summary-text">
                                <strong>{selected}</strong>
                                <p>{PARTNER_META[selected].desc}</p>
                            </div>
                        </div>


                        <div className="partners-list">
                            {PARTNERS.map((p) => (
                                <label key={p} className={`partner-option ${selected === p ? 'selected' : ''}`}>
                                    <input
                                        type="radio"
                                        name="partner"
                                        value={p}
                                        checked={selected === p}
                                        onChange={() => setSelected(p)}
                                    />
                                    <span className="partner-name">{p}</span>
                                </label>
                            ))}
                        </div>




                        <div className="actions-row">
                            <button className="back-btn" onClick={onBackClick}>Back</button>
                            <button className="refresh-btn" onClick={handleConfirm}>Confirm & Place Order</button>
                        </div>
                    </div>
                </section>
            </main>

            <footer className="footer">
                <p>© 2026 StupidDesigns.com. Parody only — we don't actually ship.</p>
            </footer>
        </div>
    );
}

export default ShippingOptions;
